import { toast } from "react-hot-toast";
import { axiosWithToast } from "../../../../components/Utils";
import {
  drivingDriverAction,
  drivingDriverVehicleActionByDriverId,
} from "../../../../api/driving/driver";

export const driverVehicleAction = async ({
  userId,
  driverId,
  vehicleId,
  action,
  onDriverUpdate,
}) => {
  // Error if action is missing
  if (!action) {
    toast.error("Error: Action is missing");
    return;
  }

  if (driverId) {
    return axiosWithToast(
      drivingDriverVehicleActionByDriverId(driverId, {
        vehicle_id: vehicleId,
        action,
      }),
      null,
      null,
      onDriverUpdate
    );
  }

  if (!userId) {
    toast.error("Error: User or driver is missing");
    return;
  }

  const payload = {
    user_id: userId,
    vehicle_id: vehicleId,
    action: action,
  };

  return axiosWithToast(drivingDriverAction(payload), null, null, onDriverUpdate);
};
